import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
    title = 'Hashtag PG & Flats - Premium Accommodations in Pune',
    description = 'Find the best PG accommodations and flats for rent in Pune. Premium amenities, great locations, and affordable prices. Book your visit today!',
    keywords = 'PG in Pune, flats for rent Pune, paying guest, accommodation Pune, rental properties',
    image = 'https://hashtagstaycomfort.in/og-image.jpg',
    url = 'https://hashtagstaycomfort.in'
}) => {
    return (
        <Helmet>
            {/* Basic Meta Tags */}
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />

            {/* Open Graph Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />
            <meta property="og:url" content={url} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Hashtag PG & Flats" />

            {/* Twitter Card Tags */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />

            {/* Additional SEO Tags */}
            <meta name="robots" content="index, follow" />
            <meta name="language" content="English" />
            <meta name="revisit-after" content="7 days" />
            <meta name="author" content="Hashtag PG & Flats" />

            {/* Canonical URL */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;
